export default "/_next/static/images/img2-31713afae6f863fe039668a33582c6ae.png";